// React
import { PropsWithChildren, useState } from 'react';

// Hooks Propios
import { useScreenSize, ScreenSize } from '@/ui/hooks/useScreenSize';

// Bootstrap / React Bootstrap / CSS
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import './style.css';

// Utilidades
import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';
import { translate } from '@/domain/utils/translate';

// Assets
import Icon from '@/ui/assets/Icon';
import CloseIcon from '@/ui/assets/CloseIcon';

// Components
import BookAppointmentModal from '@/ui/components/modals/BookAppointmentModal';
import AlertModal from '@/ui/components/modals/AlertModal';
import IconList from '@/ui/components/IconList';
import ContactInformation from '@/ui/components/store/ContactInformation';


interface FloatingButtonModalProps {
    /**
     * Indica si el modal debe mostrarse o no.
     */
    showModal: boolean;

    /**
     * Función para cerrar el modal.
     */
    handleClose: () => void;
}

/**
 * Componente de modal lateral específico para el botón flotante.
 */
const FloatingButtonModal = ({ showModal, handleClose }: PropsWithChildren<FloatingButtonModalProps>): JSX.Element => {


    /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido */
    const { width, maxLargeWidth }: ScreenSize = useScreenSize();

    /** Variable que define si es entorno mobile o desktop */
    const isMobile: boolean = width < maxLargeWidth;

    const BOOK_APPOINTMENT_LABEL: string = translate('product.book_appointment_label');

    const CONTACT_US_SUBTITLE_MODAL: string = translate('modals.contact_us_modal_subtitle');

    const CONTACT_US_TITLE_MODAL: string = translate('modals.contact_us_modal_title');

    /*trae el estilo css desde el archivo de variables css */
    const buttonVariant = getCSSVariableValue('--button-variant');

    /**trae el estilo css desde el archivo de variables css */
    const linkVariant = getCSSVariableValue('--icon-variant-light');
    /**  Estado que define si se muestra el modal de email que ya existe 	*/
    const [bookAppointment, setBookAppointment] = useState(false);


    /** Estado inicial del modal de alertas */
    const [successAlertAppointment, setSuccessAlertAppointment] = useState<boolean>(false);

    /** Estado inicial del modal de alertas */
    const [errorAlertAppointment, setErrorAlertAppointment] = useState<boolean>(false);


    const handleShowBookAppointment = () => {
        setBookAppointment(!bookAppointment);
        // Cerrar el modal lateral cuando se abre el modal de cita
        if (!bookAppointment) {
            handleClose();
        }
    }


    return (
        <>
            <Modal
                show={showModal}
                fullscreen={isMobile ? true : undefined}
                className={`${isMobile ? 'bg-transparent' : 'floating-slide-modal'}`}
                dialogClassName={`${isMobile ? 'modal-dialog-bottom' : 'modal-dialog-centered'}`}
                contentClassName={`${isMobile ? 'mobile-modal-content rounded-top-4 d-flex justify-content-between shadow' : 'rounded-top-4 mh-400-px d-flex justify-content-between shadow'}`}
                size='lg'
                onHide={handleClose}>

                {isMobile && (
                    <Col xs={12} className='text-end pe-2 py-2 d-flex justify-content-end'>
                        <CloseIcon classMain='btn-icon-light' onClick={handleClose} />
                    </Col>
                )}
                {!isMobile &&
                    <Modal.Header closeButton className='d-flex'>
                    </Modal.Header>}
                <Modal.Body>
                    <Container fluid className={`${isMobile ? 'float-button-modal-body' : ''} d-flex flex-column h-100`}>
                        <Row >
                            <Col className={`${isMobile ? 'p-0' : 'mt-1 pt-3 ps-3'} d-flex flex-column h-100 justify-content-between`}>
                                <Col className='d-flex flex-column align-items-center justify-content-center '>
                                    <IconList title={CONTACT_US_TITLE_MODAL} iconName='ico-contact-black' classTitle='h4 ps-1 fw-bold ' classMain='text-start' />
                                    <span className={`${isMobile ? 'mt-5' : 'mt-5 paragraph text-start'}`}>{CONTACT_US_SUBTITLE_MODAL}</span>
                                </Col>

                                <ContactInformation customColor='secondary-2' />

                                <Col className={`d-flex justify-content-center align-items-center ${isMobile ? 'pt-4 ' : 'py-4 mt-auto'}  `}>
                                    <Col className={`w-100`}>
                                        <Button
                                            className={`${buttonVariant} ${linkVariant} border-1 d-flex justify-content-center align-items-center w-100 py-2`}
                                            onClick={handleShowBookAppointment}
                                        >
                                            <Icon
                                                name='ico-calendar'
                                                classMain='svg-primary-1 pe-2'>
                                            </Icon>
                                            {BOOK_APPOINTMENT_LABEL.toLocaleUpperCase()}
                                        </Button>
                                    </Col>
                                </Col>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Col xs={12} className='align-self-end p-0 m-0'>
                    <div className={`${isMobile ? 'bottom-line' : 'bg-primary-1 pt-2'}`} />
                </Col>
            </Modal>
            {bookAppointment &&
                <BookAppointmentModal
                    showModal={bookAppointment}
                    onClose={handleShowBookAppointment}
                    title={BOOK_APPOINTMENT_LABEL}
                    classTitle='text-secondary-1 h2 text-center mt-4'
                    setSuccessAlertAppointment={setSuccessAlertAppointment}
                    setErrorAlertAppointment={setErrorAlertAppointment}
                />
            }

            {successAlertAppointment && (
                <AlertModal
                    hideAlert={() => setSuccessAlertAppointment(false)}
                    hide={10000}
                    type='success'
                    content={translate('store.book_success')}
                />
            )}
            {errorAlertAppointment && (
                <AlertModal
                    hideAlert={() => setErrorAlertAppointment(false)}
                    hide={10000}
                    type='danger'
                    content={translate('store.book_error')}
                />
            )}
        </>
    );
};

export default FloatingButtonModal; 